/**
 * Login con CÓDIGO DE EMPLEADO además de correo.
 *
 * Hay personal de ProMedic sin correo propio. Sus cuentas de Supabase Auth
 * usan el dominio de la empresa: `<codigo>@promedicgroup.com`
 * (p.ej. `tecnico01@promedicgroup.com`). El mismo correo existe como cuenta
 * gemela en Kane OneDeck, porque el SSO de /agente cruza las cuentas por email.
 *
 * Regla, del lado del cliente y antes de `signInWithPassword`:
 *   - si lo escrito tiene '@' → es un correo y se usa tal cual (login de siempre);
 *   - si no → es un código y se completa con el dominio de la empresa.
 *
 * El dominio se puede cambiar por build con REACT_APP_INTERNAL_LOGIN_DOMAIN
 * (CRA lo incrusta en build), sin tocar código.
 */
export const DEFAULT_INTERNAL_LOGIN_DOMAIN = 'promedicgroup.com';

export const internalLoginDomain = () =>
  (process.env.REACT_APP_INTERNAL_LOGIN_DOMAIN || DEFAULT_INTERNAL_LOGIN_DOMAIN).trim().toLowerCase();

// Código: letras, números, punto, guion o guion bajo; empieza con letra/número.
const CODE_REGEX = /^[a-z0-9][a-z0-9._-]{0,63}$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * @param {string} input - lo que la persona escribió en "Correo o código"
 * @returns {{ email: string|null, kind: 'email'|'code'|null }}
 *   `email` null = no es ni correo válido ni código válido.
 */
export const resolveLoginIdentifier = (input) => {
  const raw = typeof input === 'string' ? input.trim().toLowerCase() : '';
  if (!raw) return { email: null, kind: null };
  if (raw.includes('@')) {
    return EMAIL_REGEX.test(raw) ? { email: raw, kind: 'email' } : { email: null, kind: null };
  }
  return CODE_REGEX.test(raw)
    ? { email: `${raw}@${internalLoginDomain()}`, kind: 'code' }
    : { email: null, kind: null };
};

export default resolveLoginIdentifier;
